import { observer } from 'mobx-react';
import propTypes from 'prop-types';

import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

const _BtnFavorite = ({ handleClick, store }) => {
  const clickBtnFavHandler = (e) => {
    e.preventDefault();
    handleClick();
  };

  const classList = `figure-icon my-cart__btn-fav${store.isFavorite ? ' my-cart__btn-fav--active' : ''}`;
  const iconLink = store.isFavorite ? 'star_plain' : 'star_stroke';

  return (
    <button type="button" className={`button-less ${classList}`} onClick={clickBtnFavHandler}>
      <PesIcon class="actions-block__icon" size={pesIconSizes.MICRO}>
        {iconLink}
      </PesIcon>
    </button>
  );
};

_BtnFavorite.propTypes = {
  handleClick: propTypes.func.isRequired,
  store: propTypes.shape({
    isFavorite: propTypes.bool.isRequired
  }).isRequired
};

export const BtnFavorite = observer(_BtnFavorite);
